import { render } from "./comentario.vue?vue&type=template&id=64c856db&scoped=true"
import script from "./comentario.vue?vue&type=script&lang=js"
export * from "./comentario.vue?vue&type=script&lang=js"

import "./comentario.vue?vue&type=style&index=0&id=64c856db&scoped=true&lang=css"
import "./comentario.vue?vue&type=style&index=1&id=64c856db&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c856db"]])

export default __exports__